module.exports = __webpack_public_path__ + "static/img/winners-first.ebc046f0.jpg";